import { ReactNode, createContext, useContext, useMemo, useState } from 'react';
import type { ConnectionHealth } from '../types';

type ConnectionStatusContextValue = {
  backend: ConnectionHealth;
  livekit: ConnectionHealth;
  setBackendStatus: (status: ConnectionHealth) => void;
  setLivekitStatus: (status: ConnectionHealth) => void;
};

const ConnectionStatusContext = createContext<ConnectionStatusContextValue | undefined>(undefined);

export function ConnectionStatusProvider({ children }: { children: ReactNode }) {
  const [backend, setBackend] = useState<ConnectionHealth>('disconnected');
  const [livekit, setLivekit] = useState<ConnectionHealth>('disconnected');

  const value = useMemo(
    () => ({
      backend,
      livekit,
      setBackendStatus: setBackend,
      setLivekitStatus: setLivekit,
    }),
    [backend, livekit],
  );

  return <ConnectionStatusContext.Provider value={value}>{children}</ConnectionStatusContext.Provider>;
}

export function useConnectionStatus() {
  const context = useContext(ConnectionStatusContext);
  if (!context) {
    throw new Error('useConnectionStatus must be used within a ConnectionStatusProvider');
  }
  return context;
}
